import { render, staticRenderFns } from "./PH1V_S20.vue?vue&type=template&id=73e75612&scoped=true"
import script from "./PH1V_S20.vue?vue&type=script&lang=js"
export * from "./PH1V_S20.vue?vue&type=script&lang=js"
import style0 from "./PH1V_S20.vue?vue&type=style&index=0&id=73e75612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e75612",
  null
  
)

export default component.exports